module.exports = __webpack_public_path__ + "img/grin-squint.2ec62cf9.svg";